import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingBag, Menu, X } from 'lucide-react';
import { useCart } from '../context/CartContext';
export function Header() {
  const {
    openCart,
    count
  } = useCart();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname, location.hash]);
  const navLinks = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'Shop',
    href: '/shop'
  }, {
    name: 'Ons Verhaal',
    href: '/#story'
  }, {
    name: 'Verkooppunten',
    href: '/#retailers'
  }, {
    name: 'Contact',
    href: '/contact'
  }];
  // If we are not on the home page, the header should always have a solid background
  // to avoid text clashing with page content that doesn't have a dark hero image.
  const isHomePage = location.pathname === '/';
  const headerSolid = isScrolled || !isHomePage || isMobileMenuOpen;
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${headerSolid ? 'bg-white/95 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-128">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-129">
        {/* Logo */}
        <Link to="/" aria-label="Capsin home" className="flex items-center z-50" data-id="element-130">
          <img src="https://cdn.magicpatterns.com/uploads/aqfFtawQLdvdgEuWf1RLRX/ColorGREENTransperant.png" alt="Capsin - Authentiek genieten" className={`w-auto object-contain transition-all duration-300 ${headerSolid ? 'h-12' : 'h-14 drop-shadow-lg'}`} data-id="element-131" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-132">
          {navLinks.map(link => <Link key={link.name} to={link.href} className={`text-sm font-medium tracking-wide hover:text-brand-red transition-colors ${headerSolid ? 'text-brand-dark' : 'text-white drop-shadow-sm'}`} data-id="element-133">
              {link.name}
            </Link>)}
        </nav>

        {/* Actions */}
        <div className="flex items-center gap-4 z-50" data-id="element-134">
          <button onClick={openCart} aria-label="Open winkelwagen" className={`relative p-2 hover:scale-110 transition-transform ${headerSolid ? 'text-brand-dark' : 'text-white'}`} data-id="element-135">
            <ShoppingBag size={24} data-id="element-136" />
            {count > 0 && <span className="absolute top-0 right-0 bg-brand-red text-white text-[10px] font-bold w-4 h-4 rounded-full flex items-center justify-center" data-id="element-137">
                {count}
              </span>}
          </button>

          <button className={`md:hidden p-2 ${headerSolid ? 'text-brand-dark' : 'text-white'}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-138">
            {isMobileMenuOpen ? <X size={24} data-id="element-139" /> : <Menu size={24} data-id="element-140" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`fixed inset-0 bg-brand-cream z-40 transition-transform duration-300 ease-in-out ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'} md:hidden flex flex-col justify-center items-center gap-8`} data-id="element-141">
        {navLinks.map(link => <Link key={link.name} to={link.href} className="font-serif text-3xl text-brand-dark hover:text-brand-red transition-colors" data-id="element-142">
            {link.name}
          </Link>)}
      </div>
    </header>;
}